module.exports = __webpack_public_path__ + "images/interlab-logo-large.png";